"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertDataLeakageTextComponent = void 0;
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var styles = require("../styles/DataAlerts");
var filterBySuccess = function (values, percentSuccess) {
    return values.filter(function (value) { return value.meetsAlertCriteria && value.percentSuccess === percentSuccess; }).map(function (value) { return value.label; });
};
var AlertDataLeakageTextComponent = function (props) {
    var _a = props.relatedData, values = _a.values, referenceField = _a.referenceField, outcome = _a.outcome;
    var allSuccessValues = filterBySuccess(values, 100);
    var allFailureValues = filterBySuccess(values, 0);
    var renderSection = function (valuesMeetingCriteria, isSecondSection, outcomeValue) {
        var dataLeakageMessagePluralSecond = Localize_1.Messages.DataLeakageMessagePluralSecond({
            outcomeLabel: outcome.label,
            outcomeValue: outcomeValue,
        });
        var dataLeakageMessagePlural = Localize_1.Messages.DataLeakageMessagePlural({
            outcomeLabel: outcome.label,
            outcomeValue: outcomeValue,
            fieldLabel: referenceField.label,
        });
        var dataLeakageMessageSingularSecond = Localize_1.Messages.DataLeakageMessageSingularSecond({
            outcomeLabel: outcome.label,
            outcomeValue: outcomeValue,
        });
        var dataLeakageMessageSingular = Localize_1.Messages.DataLeakageMessageSingular({
            outcomeLabel: outcome.label,
            outcomeValue: outcomeValue,
            fieldLabel: referenceField.label,
        });
        var message;
        if (values.length > 1) {
            message = isSecondSection ? dataLeakageMessagePluralSecond : dataLeakageMessagePlural;
        }
        else {
            message = isSecondSection ? dataLeakageMessageSingularSecond : dataLeakageMessageSingular;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null, message),
            React.createElement("ul", { className: styles.alertDataLeakageCriteriaList }, valuesMeetingCriteria.map(function (value) { return (React.createElement("li", { key: value }, value)); }))));
    };
    return (React.createElement("div", { className: styles.alertDataLeakageText },
        allSuccessValues.length > 0 && renderSection(allSuccessValues, false, outcome.successValue),
        allFailureValues.length > 0 && renderSection(allFailureValues, allSuccessValues.length > 0, outcome.failureValue),
        React.createElement("div", null, Localize_1.Messages.DataLeakageFollowUp({ fieldLabel: referenceField.label }))));
};
exports.AlertDataLeakageTextComponent = AlertDataLeakageTextComponent;
//# sourceMappingURL=AlertDataLeakageTextComponent.js.map